import React, { useEffect, useState } from "react";
import PlayerTable from "../../table/playerTable";
import ProfileStatisticsHeader from "./profileStatisticsHeader";
// import ProfileStatisticsRecentStories from "./profileStatisticsRecentStories";
// import ProfileStatisticsSimilarPlayers from "./profileStatisticsSimilarPlayers";
import ProfileStatisticsTopScorer from "./profileStatisticsTopScorer";

export default function ProfileStatisticsSection(props: any) {
    const statisticsData = props?.data;
    console.log("profilestat >",props)
    const [selectStatistics, setSelectStatistics] = useState(0)
    let onChangeStatistics = (value: number) => {
        setSelectStatistics(value)
    }
    useEffect(() => {
        if (statisticsData?.availableStatistics) {
            if (!statisticsData?.availableStatistics["batting"]) {
                setSelectStatistics(1)
            } else if (!statisticsData?.availableStatistics["pitcher"]) {
                setSelectStatistics(2)
            }
        }
    }, [statisticsData])

    return (
        <div className="statistics-tab">
            <ProfileStatisticsHeader activated={selectStatistics} dropdown={statisticsData?.availableStatistics} onChange={onChangeStatistics} />
            {props?.isTeam ?
                <ProfileStatisticsTopScorer topperDetails={props?.topperDetails || []}/>
                : null
            }
            <PlayerTable data={statisticsData} selectStatistics={selectStatistics} isTeam={props?.isTeam}/>
            {/* <div className="player-table-title theme-light-white">
                <h3 className="mb-0 bold">Expanded-Batting</h3>
            </div>
            <PlayerTable />
            <div className="player-table-title theme-light-white">
                <h3 className="mb-0 bold">Advanced-Batting</h3>
            </div>
            <PlayerTable /> */}
            {/* <ProfileStatisticsSimilarPlayers />
      <ProfileStatisticsRecentStories /> */}
        </div>
    );
}
